"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _reactQuery = require("react-query");

var _IconCheckCircleAlt = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconCheckCircleAlt"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _serviceClients = require("@cimpress-technology/service-clients");

var _ErrorRobot = _interopRequireDefault(require("./ErrorRobot"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _SkuCsvDownloadLink = _interopRequireDefault(require("./SkuCsvDownloadLink"));

var _SkuProductCardList = _interopRequireDefault(require("./SkuProductCardList"));

var SuccessMessageDiv = _styledComponents["default"].div.withConfig({
  displayName: "src__SuccessMessageDiv",
  componentId: "sc-1j7p3t6-0"
})(["align-items:center;display:flex;flex-direction:column;margin-top:20px;margin-bottom:24px;"]);

var QuickCreate = function QuickCreate(_ref) {
  var getAccessToken = _ref.getAccessToken,
      buyerAccountId = _ref.buyerAccountId,
      skuFamilyId = _ref.skuFamilyId,
      isProduction = _ref.isProduction,
      onCreated = _ref.onCreated;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      skus = _useState2[0],
      setSkus = _useState2[1]; // eslint-disable-next-line no-unused-vars


  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      skuFamilyName = _useState4[0],
      setSkuFamilyName = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      buyerAccount = _useState6[0],
      setBuyerAccount = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      merchants = _useState8[0],
      setMerchants = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      fulfiller = _useState10[0],
      setFulfiller = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      familySkusWithoutCatalogPrice = _useState12[0],
      setFamilySkusWithoutCatalogPrice = _useState12[1];

  var _useState13 = (0, _react.useState)(null),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      selectedMerchant = _useState14[0],
      setSelectedMerchant = _useState14[1];

  var _useState15 = (0, _react.useState)(null),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      contractName = _useState16[0],
      setContractName = _useState16[1];

  var _useState17 = (0, _react.useState)(true),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      loading = _useState18[0],
      setLoading = _useState18[1];

  var _useState19 = (0, _react.useState)(null),
      _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
      error = _useState20[0],
      setError = _useState20[1];

  var _createPricingTerm =
  /*#__PURE__*/
  function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      var pricingTermClient, pricingTerm;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pricingTermClient = new _serviceClients.PricingTermClient(getAccessToken, isProduction);
              _context.next = 3;
              return pricingTermClient.createCatalogPriceTerm(fulfiller.fulfillerId, selectedMerchant.value, skus, contractName);

            case 3:
              pricingTerm = _context.sent;

              if (!(typeof onCreated === 'function')) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return Promise.resolve(onCreated(pricingTerm));

            case 7:
              return _context.abrupt("return", pricingTerm);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function _createPricingTerm() {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useMutation = (0, _reactQuery.useMutation)(_createPricingTerm),
      _useMutation2 = (0, _slicedToArray2["default"])(_useMutation, 2),
      mutate = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      createdPricingTerm = _useMutation2$.data,
      isCreatingPricingTerm = _useMutation2$.isLoading,
      createPricingTermError = _useMutation2$.error;

  var createPricingTerm = mutate;
  (0, _react.useEffect)(function () {
    var loadInitialData =
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        var accountsClient, buyerAcc, skuFamilyClient, _ref4, skuFamName, allSkusUnderFamily, skuFamilyFulfillerId, fulfillerClient, skuFamilyFulfiller, coamClient, hasPermissionToCreateContract, merchantsClient, merchantsUnderAccount, productPriceClient, allCatalogPriceModels, skusWithCatalogPrice, famSkusWithoutCatalogPrice;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                accountsClient = new _serviceClients.AccountsClient(getAccessToken);
                _context2.next = 4;
                return accountsClient.getAccount(buyerAccountId);

              case 4:
                buyerAcc = _context2.sent;

                if (buyerAcc) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('You do not have permission to create a contract with this business.');

              case 7:
                skuFamilyClient = new _serviceClients.SkuFamilyClient(getAccessToken);
                _context2.next = 10;
                return skuFamilyClient.getSkusUnderFamily(skuFamilyId);

              case 10:
                _ref4 = _context2.sent;
                skuFamName = _ref4.name;
                allSkusUnderFamily = _ref4.skus;
                skuFamilyFulfillerId = _ref4.fulfillerId;

                if (!(!allSkusUnderFamily || !allSkusUnderFamily.length)) {
                  _context2.next = 16;
                  break;
                }

                throw new Error("There are no SKUs available under family ".concat(skuFamilyId));

              case 16:
                fulfillerClient = new _serviceClients.FulfillerIdentityClient(getAccessToken);
                _context2.next = 19;
                return fulfillerClient.getFulfiller(skuFamilyFulfillerId);

              case 19:
                skuFamilyFulfiller = _context2.sent;

                if (skuFamilyFulfiller) {
                  _context2.next = 22;
                  break;
                }

                throw new Error("You do not have permission to the owner of sku family ".concat(skuFamilyId, "."));

              case 22:
                coamClient = new _serviceClients.CoamClient(getAccessToken);
                _context2.next = 25;
                return coamClient.hasPermissionsFor('fulfillers', '*', 'create:pricing-term');

              case 25:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 29;
                return coamClient.hasPermissionsFor('fulfillers', skuFamilyFulfiller.fulfillerId, 'create:pricing-term');

              case 29:
                _context2.t0 = _context2.sent;

              case 30:
                hasPermissionToCreateContract = _context2.t0;

                if (hasPermissionToCreateContract) {
                  _context2.next = 33;
                  break;
                }

                throw new Error("You do not have permission to create a contract for fulfiller ".concat(skuFamilyFulfiller.fulfillerId));

              case 33:
                merchantsClient = new _serviceClients.MerchantConfigurationClient(getAccessToken);
                _context2.next = 36;
                return merchantsClient.getMerchantsUnderAccount(buyerAccountId);

              case 36:
                merchantsUnderAccount = _context2.sent;

                if (!(!merchantsUnderAccount || !merchantsUnderAccount.length)) {
                  _context2.next = 39;
                  break;
                }

                throw new Error("There are no merchant identities under business ".concat(buyerAcc.name));

              case 39:
                productPriceClient = new _serviceClients.ProductPriceClient(getAccessToken, isProduction);
                _context2.next = 42;
                return productPriceClient.getListPriceModels(skuFamilyFulfiller.fulfillerId, allSkusUnderFamily);

              case 42:
                allCatalogPriceModels = _context2.sent;
                skusWithCatalogPrice = new Set(allCatalogPriceModels.flatMap(function (priceModel) {
                  return priceModel.skus;
                }));
                famSkusWithoutCatalogPrice = allSkusUnderFamily.filter(function (sku) {
                  return !skusWithCatalogPrice.has(sku);
                });

                if (!(famSkusWithoutCatalogPrice.length > 0)) {
                  _context2.next = 48;
                  break;
                }

                setFamilySkusWithoutCatalogPrice(famSkusWithoutCatalogPrice);
                throw new Error("Sku(s) are missing catalog prices.");

              case 48:
                if (!(!merchantsUnderAccount || !merchantsUnderAccount.length)) {
                  _context2.next = 50;
                  break;
                }

                throw new Error("There are no merchant identities under business ".concat(buyerAcc.name));

              case 50:
                setBuyerAccount(buyerAcc);
                setSkuFamilyName(skuFamName);
                setSkus(allSkusUnderFamily);
                setMerchants(merchantsUnderAccount);
                setSelectedMerchant({
                  label: merchantsUnderAccount[0].merchantName,
                  value: merchantsUnderAccount[0].merchantId
                });
                setFulfiller(skuFamilyFulfiller);
                setContractName("Contract for ".concat(skuFamName, " (").concat(allSkusUnderFamily.length === 1 ? allSkusUnderFamily[0] : "Sku Family ".concat(skuFamilyId), ")"));
                _context2.next = 62;
                break;

              case 59:
                _context2.prev = 59;
                _context2.t1 = _context2["catch"](0);
                setError(_context2.t1.message);

              case 62:
                _context2.prev = 62;
                setLoading(false);
                return _context2.finish(62);

              case 65:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 59, 62, 65]]);
      }));

      return function loadInitialData() {
        return _ref3.apply(this, arguments);
      };
    }();

    loadInitialData();
  }, [buyerAccountId, getAccessToken, skuFamilyId, isProduction]);

  if (loading) {
    return _react["default"].createElement(_Loading["default"], {
      text: "Loading resources..."
    });
  }

  if (createdPricingTerm) {
    return _react["default"].createElement(SuccessMessageDiv, null, _react["default"].createElement(_IconCheckCircleAlt["default"], {
      color: _reactComponents.colors.success.base,
      size: "5x"
    }), _react["default"].createElement("h4", null, 'Success!'), _react["default"].createElement("p", null, "Go to", ' ', _react["default"].createElement("a", {
      href: "https://".concat(isProduction ? '' : 'stg-', "contractmanager.ff.cimpress.io/").concat(createdPricingTerm.termId, "/").concat(createdPricingTerm.revisionId),
      rel: "noopener noreferrer",
      target: "_blank"
    }, "Contract Manager"), ' ', "to view your contract."));
  }

  if (error || createPricingTermError) {
    return _react["default"].createElement(_ErrorRobot["default"], {
      msg: _react["default"].createElement("div", null, _react["default"].createElement("h5", null, error), _react["default"].createElement("h5", null, createPricingTermError && createPricingTermError.message), familySkusWithoutCatalogPrice && familySkusWithoutCatalogPrice.length > 0 && _react["default"].createElement(_SkuCsvDownloadLink["default"], {
        message: "click here to download the list of SKUs missing catalog price.",
        skus: familySkusWithoutCatalogPrice
      }))
    });
  }

  var merchantOptions = merchants.map(function (merchant) {
    return {
      type: 'merchants',
      value: merchant.merchantId,
      label: merchant.merchantName
    };
  });
  return _react["default"].createElement("div", {
    style: {
      maxWidth: '568px',
      margin: '0 auto'
    }
  }, _react["default"].createElement("label", null, "Contract Name"), _react["default"].createElement(_reactComponents.TextField, {
    label: "Contract Name",
    name: "contractName",
    onChange: function onChange(e) {
      return setContractName(e.target.value);
    },
    value: contractName
  }), _react["default"].createElement("label", null, "Seller (You)"), _react["default"].createElement(_reactComponents.TextField, {
    disabled: true,
    name: "sellerFulfiller",
    value: "".concat(fulfiller.name, " (").concat(fulfiller.fulfillerId, ")")
  }), _react["default"].createElement("label", null, "Buyer ", merchants.length > 1 && "(If unsure, please reach out to ".concat(buyerAccount.name, ")")), merchants.length === 1 ? _react["default"].createElement(_reactComponents.TextField, {
    disabled: true,
    name: "buyerMerchant",
    value: merchants[0].merchantName
  }) : _react["default"].createElement(_reactComponents.Select, {
    label: "Merchant",
    name: "buyerMerchant",
    onChange: function onChange(selected) {
      setSelectedMerchant(selected);
    },
    options: merchantOptions,
    value: selectedMerchant
  }), _react["default"].createElement("label", null, "SKU(s)"), _react["default"].createElement(_SkuProductCardList["default"], {
    getAccessToken: getAccessToken,
    skus: skus
  }), _react["default"].createElement("div", {
    style: {
      "float": 'right',
      marginTop: '8px',
      textAlign: 'right'
    }
  }, _react["default"].createElement("button", {
    className: "btn btn-primary",
    disabled: isCreatingPricingTerm || createdPricingTerm,
    onClick: createPricingTerm,
    type: "submit"
  }, isCreatingPricingTerm ? 'Creating...' : 'Create')));
};

var _default = QuickCreate;
exports["default"] = _default;